import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, ResponsiveContainer, Tooltip, Line, LineChart, AreaChart, Area, Legend } from 'recharts';

import './Graph.scss';
const Graph = ({ data, title, loading, error, isIntegerYAxis = false, dataKey }) => {
    if (loading) return <div>Loading graph...</div>;
    if (error) return <div>Error: {error}</div>;

    return (
        <div className="bar-graph">
            <h3>{title} Graph</h3>
            
            {data && data.length > 0 ? (
                <ResponsiveContainer width="100%" height={400}>
                    <BarChart data={data}
                    style={{ width: '100%', maxWidth: '700px', maxHeight: '70vh', aspectRatio: 1.618 }}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="x" />
                        <YAxis
                            type="number"
                            domain={[0, 'dataMax']}
                            allowDecimals={!isIntegerYAxis}
                            tickFormatter={isIntegerYAxis ? (value) => Math.round(value) : undefined}
                        />   
                        <Tooltip />
                        <Legend />
                        <Bar type="monotone" dataKey={dataKey} fill="#8884d8" />
                    </BarChart>
                </ResponsiveContainer>
            ) : (
                <p>No data available.</p>
            )}
        </div>
    );
};

export default Graph;